module.exports = __webpack_public_path__ + "207cbcf20b03f35735ba2cfae8b5ec61.png";